import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  signal,
  ViewEncapsulation,
  WritableSignal,
} from '@angular/core';
import { PlIcon } from '@app/icon-library/icons';
import { ProgressBarHeight, SliderColor } from '../pl-slider/pl-slider.component';

@Component({
  selector: 'pl-audio',
  templateUrl: './pl-audio.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class PlAudioComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input({ required: true }) public title!: string;
  @Input({ required: true }) public link!: string;

  public userClickedOnceOnPlayButton: WritableSignal<boolean> = signal(false);

  protected readonly PlIcon: typeof PlIcon = PlIcon;
  protected readonly ProgressBarHeight: typeof ProgressBarHeight = ProgressBarHeight;
  protected readonly SliderColor: typeof SliderColor = SliderColor;

  public audioTimeProgress: number = 0;
  public audio: HTMLMediaElement | null = null;

  public async ngOnInit(): Promise<void> {
    this.audio = new Audio();
    this.audio.src = this.link;

    this.audio.ontimeupdate = (): void => {
      console.log(
        'TONIO PlAudioComponent.ontimeupdate this.audio.currentTime=',
        this.audioTrack.currentTime,
        '  this.audioTrack.paused=',
        this.audioTrack.paused,
      );
      if (!this.audioTrack.paused) {
        this.audioTimeProgress = this.audioTrack.currentTime;
      }
    };
  }

  public ngOnDestroy(): void {
    this.pauseTrack();
    this.audioTrack.remove();
  }

  public onSliderChange(timeSet: number): void {
    this.audioTrack.currentTime = timeSet;
  }

  public async onPlayPauseClicked(): Promise<void> {
    console.log('TONIO PlAudioComponent onPlayPauseClicked=');
    if (this.audioTrack.paused) {
      await this.playTrack();
    } else {
      this.pauseTrack();
    }
    this.userClickedOnceOnPlayButton.set(true);
  }

  public ngAfterViewInit(): void {}

  private pauseTrack(): void {
    console.log(
      '\x1b[41m TONIO PlAudioComponent pauseTrack this.audioTrack.currentTime=',
      this.audioTrack.currentTime,
      '\x1b',
    );
    this.audioTrack.pause();
  }

  private async playTrack(): Promise<void> {
    console.log(
      '\x1b[41m TONIO PlAudioComponent playTrack this.audioTrack.currentTime=',
      this.audioTrack.currentTime,
      '\x1b',
    );
    await this.audioTrack.play();
  }

  private get audioTrack(): HTMLMediaElement {
    if (this.audio) {
      return this.audio;
    }

    throw new Error(`We should never get the audioTrack if it's not initialised`);
  }
}
